import { detalheExtrato } from '@/views/10/RegrasDeNegocio10'
import moment from 'moment'

const preloadWidget = async (row, funcionalidade, authorization) => {
  const detalhe = await detalheExtrato(row.idReembolso, row.numeroGuiaReembolso)
  return createPayload(detalhe, funcionalidade, authorization)
}

const parseDate = (value) => {
  if (!value) {
    return '-'
  }
  if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }
  try {
    return moment(Number.parseInt(value)).format('DD/MM/YYYY')
  } catch (ignored) {
    return moment(value).format('DD/MM/YYYY')
  }
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {},
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  const { configuracoesDeWidgets } = funcionalidade.parametros

  if (configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioEmailWidget && configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioWhatsappWidget && configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': true
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': 'Extrato de Reembolso',
    'nomeIntegracao': 'detalhe',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {
        ...funcionalidade.rotas.detalhe
      },
      'payload': {
        'idReembolso': detalhe.idReembolso,
        'numeroGuiaReembolso': detalhe.numeroGuiaReembolso
      }
    },
    'data': {
      'tituloWidget': `${funcionalidade.nome}`,
      'textoWidget': `Solicitacao criada em: ${(detalhe.dataSolicitacao) ? parseDate(detalhe.dataSolicitacao) : parseDate(detalhe.data_registro)}, sob o numero de protocolo: ${(detalhe.numeroProtocolo) ? detalhe.numeroProtocolo : detalhe.protocolo} com status de "${(detalhe.situacao) ? detalhe.situacao.descricao : detalhe.status_label}"`,
      ...detalhe,
      ...detalhe.guia
    }
  })
  return payload
}
export { preloadWidget }
